/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
import styled from "styled-components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

// Stylings

const InnerContainer = styled.div`
  width: 520px;
  height: 280px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  text-align: center;
  position: absolute;
  font-family: "Roboto", sans-serif;
  z-index: 100;
  animation: zoomIn 0.2s ease-in-out;
  position: fixed;
`;
const TextContainer = styled.div`
  height: 58%;
`;
const Br = styled.div`
  height: 15%;
`;
const HeaderText = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 50%;
  color: ${(props) => props.theme.colors.black};
  height: 25%;
`;
const ParagraphText = styled.div`
  font-size: 16px;
  line-height: 135%;
  color: ${(props) => props.theme.colors.black};
  width: 85%;
  display: inline-table;
`;
const ButtonContainer = styled.button`
  width: 40%;
  height: 77%;
  background: ${(props) => props.theme.colors.darkGreen};
  border-radius: 4px;
  cursor: pointer;
  border: none;
  :disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
const ButtonContainerLine = styled.div`
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: space-evenly;
  margin-top: -20px;
`;
const GetStartedButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.white};
  width: 100%;
`;
const ShowInfoButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.darkGreen};
  width: 100%;
`;
// TODO: Fix this, this is temporary fix
const StarGamePopUp = ({
  show,
  toggleStartGamePopUp,
  toggleBeginTurnPopUp,
  toggleProject,
  tasks,
  playerCurrentPosition,
  sendCardsToServer,
  playerId,
  gameId,
  updatedCards,
  notUpdatedCards,
  changesMade,
  setChangesMade,
  projectScopeDisabled,
  disableExecuteBtn,
  setIsGameStarted,
  lastFlipped,
}) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (show) {
    return (
      <InnerContainer>
        <Br />
        <TextContainer>
          <HeaderText>
            {playerCurrentPosition != 0 ? t('modals.confirm_project_changes.info_title') : t('modals.start_playing.info_title')}
          </HeaderText>
          <ParagraphText>
            {" "}
            {playerCurrentPosition != 0
              ? t('modals.confirm_project_changes.info_text')
              : t('modals.start_playing.info_text')}
          </ParagraphText>
        </TextContainer>
        <ButtonContainerLine>
          <ButtonContainer
            onClick={() => {
              if (playerCurrentPosition != 0) {
                toggleStartGamePopUp(false);
                toggleProject(0, notUpdatedCards);
              } else {
                toggleStartGamePopUp(false);
                projectScopeDisabled(false);
                disableExecuteBtn(false);
              }
            }}
            style={{ backgroundColor: "#81818c" }}
          >
            <GetStartedButton>
              {" "}
              {playerCurrentPosition != 0
                ? t('modals.confirm_project_changes.button2')
                : t('modals.start_playing.button2')}
            </GetStartedButton>
          </ButtonContainer>
          {playerCurrentPosition === 0 && (
            <ButtonContainer
              disabled={isSubmitting}
              onClick={async () => {
                if (isSubmitting) return;
                setIsSubmitting(true);
                lastFlipped.current = tasks?.filter((e) => e.isOrFlipped).length || 0
                try {
                  toggleStartGamePopUp(false);
                  await sendCardsToServer(
                    updatedCards,
                    0,
                    playerId,
                    gameId,
                    true,
                    changesMade
                  );
                  toggleProject(0, updatedCards);
                  toggleBeginTurnPopUp(true);
                  console.log("YO");
                  setIsGameStarted(true);
                } finally {
                  setIsSubmitting(false);
                }
              }}
            >
              <GetStartedButton>{t('modals.start_playing.button1')}</GetStartedButton>
            </ButtonContainer>
          )}
          {playerCurrentPosition != 0 && (
            <ButtonContainer
              disabled={isSubmitting}
              onClick={async () => {
                if (isSubmitting) return;
                setIsSubmitting(true);
                try {
                  toggleStartGamePopUp(false);
                  // console.log('taskssss', updatedCards, tasks);
                  await sendCardsToServer(
                    updatedCards,
                    0,
                    playerId,
                    gameId,
                    false,
                    changesMade
                  );
                  toggleProject(0, tasks);
                } finally {
                  setIsSubmitting(false);
                }
              }}
            >
              <GetStartedButton>{t('modals.confirm_project_changes.button1')}</GetStartedButton>
            </ButtonContainer>
          )}
        </ButtonContainerLine>
      </InnerContainer>
    );
  }
  return null;
};
export default React.memo(StarGamePopUp);
